// English language file www.qrespi.com website

// @Author: Tom Voorneveld <root>
// @Date:   2016-10-17T15:01:53+02:00
// @Email:  tom@lorinthe.com
// @Project: Lorinthe
// @Last modified by:   tom
// @Last modified time: 2019-05-17T11:19:19+02:00
// @License: Copyright Lorinthe BV, The Netherlands. All rights reserved
/* eslint-disable */
var en;

en = {
  title: {
    hashtags: 'care, safety, alone ',
    slogan: 'Qrespi - Connect to Care',
    subtitle: 'More people live alone and community care is no longer a given. It\'s time to act…',
    alt: 'Qrespi International - The Netherlands'
  },
  intro: {
    embedvideo: {
      title: 'Living alone?'
    },
    preorder: {
      progress: 'pre-orders so far',
      payload: 'Support us to reach our production-start-goal',
      button: 'pre-order <b>30%&nbsp;OFF</b>'
    },
    1: {
      title: 'Connect to Care',
      payload: 'Qrespi supports <b>mutual care</b> between <b>people who live alone</b> and their friends, family or neighbours.'
    },
    2: {
      title: 'Puck by Qrespi™',
      list: {
        1: '<b>neighbour attention button</b>',
        2: 'live <b>safely alone</b>',
        3: 'tap on Puck to notify a <b>chat group</b>',
        4: 'no reaction? Puck can even <b>call someone</b>!',
        5: 'surprisingly <b>affordable</b>'
      },
      tooltip: {
        3: 'Puck will send the message to an ordinary chat group with neighbour, family or friends. To deliver the message, you can choose Telegram and soon WhatsApp, Slack or Facebook Messenger'
      }
    },
    more: 'Read more about Puck'
  },
  puck: {
    label: 'puck',
    title: 'More about Puck',
    subtitle: 'Puck by Qrespi™',
    lead: 'Touch to Care',
    about: {
      label: 'what is Puck',
      title: 'What is Puck?',
      subtext: 'Puck by Qrespi is a small device with a big button. You install Puck for example in bathroom or next to the front door. When you tap the button, you immediately send a chat-alert to a chat group.<br/><br/>The friends, family or neighbours who are member of that chat group will receive a notification of your attention signal. If it takes too long for people to see the attention signal, Puck can even make some automated phone calls.',
      chatapps: {
        1: 'telegram.svg',
        2: 'wa.svg',
        3: 'slack.svg',
        4: 'fbm.svg'
      }
    },
    workflow: {
      label: 'workflow',
      title: 'Workflow'
    },
    slides: {
      title: 'Changing society',
      1: {
        title: 'Current Society…',
        caption: '… so many people live alone'
      },
      2: {
        title: 'There are Moments…',
        caption: '… we all can use some help'
      },
      3: {
        title: 'Puck by Qrespi…',
        caption: '… being safe and connected'
      },
      4: {
        title: 'To connect us together…',
        caption: '…for mutual care and support'
      }
    },
    specifications: {
      label: 'specifications',
      title: 'Specifications',
      payload: '',
      disclaimer: 'Concerns Puck version 1.0; changes without notice',
      images: {
        1: {
          _img: 'puck-exploded-view-v01.png',
          title: 'Exploded View'
        },
        2: {
          _img: 'puck-dimensions-v01.png',
          title: 'Dimensions'
        }
      },
      1: {
        label: 'physical dimensions',
        payload: 'size: 65x65x16mm (2.6x2.6x0.63"), weight: 80 gram (2.8 ounce) (approximate)'
      },
      2: {
        label: 'batteries',
        payload: 'Puck is powered by 3 AAA-type batteries that you can replace by opening the case with a normal Phillips-head screwdriver (PZ1)'
      },
      3: {
        label: 'water resistant',
        payload: 'Puck is water-resistant, but not waterproof. You can not take it in the bath. Showering should be OK, but we recommend not exposing Puck to soaps or anything that can negatively affect water-seals.'
      },
      4: {
        label: 'touch-buttons',
        payload: 'Puck has three touch buttons. They are non-mechanical. Puck contains no moving objects that can wear out. Inside Puck there are two micro switches: to reset Puck to factory state or to connect to the WiFi.'
      },
      5: {
        label: 'material',
        payload: 'white ABS (plastic), shiny surface'
      },
      6: {
        label: 'magnets',
        payload: 'Puck comes with two magnets on it\'s backside. You can attach Puck to any steel surface. Note that stainless steel not always contains enough iron to make Puck stick.'
      },
      7: {
        label: 'LED bar',
        payload: 'A bi-colour, red/green, bar with 10 LEDs. Puck will indicate WiFi signal strength using this bar. We also use this bar to count-down before an alarm sets of.'
      },
      8: {
        label: 'LED touch',
        payload: 'Next to each touch button we have a red LED that lights up when you press that button.'
      },
      9: {
        label: 'sound',
        payload: 'A small speaker gives audio-feedback with simple user-selectable melodies.'
      },
      10: {
        label: 'labels',
        payload: 'PVC adhesive sticker'
      }
    }
  },
  prices: {
    label: 'price',
    title: 'Prices ',
    header: 'What it costs',
    lead: 'Puck is surprisingly affordable!',
    puck: {
      label: 'puck',
      title: 'Get your own Puck',
      slot: 'For a minimal amount you could feel safer for many years to come. Please note we now have a <b>limited 30% discount</b>, so act quickly!',
      note: '* Prices are subject to change depending on future circumstances.<br>** Fair use policy: do not let kids play with Puck...;)<br>*** 7x24 hours operational, but please note that technical issues can always appear.<br>**** Depending on the country and your phone number, separate calling fees will be charged.',
      puck_set: {
        _color: 'primary',
        header: 'Your Puck',
        1: 'three coloured stick-on labels',
        2: 'magnetic, adhesive wall-mount disc',
        3: 'AAA batteries (3x)',
        4: 'quick start guide',
        5: 'leaflets to share with neighbours',
        6: 'free plan',
        note: 'Consider your own situation!',
        pack: {
          label: 'Set with:',
          1: {
            contains: '1',
            note: 'Puck: for smaller apartments',
            _img: 'one-puck.png',
            _eur: '34.75'
          },
          2: {
            contains: '2',
            note: 'Pucks: bathroom, front door',
            _img: 'two-pucks.png',
            _eur: '63.50'
          },
          3: {
            contains: '4',
            note: 'Pucks: bathroom, kitchen, front door, bedroom',
            _img: 'four-pucks.png',
            _eur: '115'
          }
        }
      },
      free_plan: {
        _color: 'secondary',
        _cardgroup: 'start',
        header: 'Free Plan',
        1: 'free web-account',
        2: 'manage your Puck and service',
        3: 'choose your own sound effects',
        4: 'Puck 7x24 heartbeat***',
        5: 'for <a href="https://www.telegram.org" target="_blank">Telegram</a> only',
        6: 'maximal one alert per day**',
        note: 'Simple!',
        pack: {
          label: 'Our daily service:',
          1: {
            contains: 'free',
            note: 'operational service',
            _eur: '0'
          }
        }
      },
      standard_plan: {
        _color: 'dark',
        _cardgroup: 'end',
        header: 'Care Plan',
        1: 'all of free plan',
        2: 'automated follow-up alerts',
        3: 'automated robot calls****',
        4: ' <a href="https://www.telegram.org" target="_blank">Telegram</a>, WhatsApp, FB Messenger',
        5: 'unlimited alerts**',
        note: 'Recommended!',
        pack: {
          label: 'Payment:',
          1: {
            contains: 'yearly',
            note: 'monthly fee when paid <u>per year</u> in advance',
            _eur: '1.75'
          },
          2: {
            contains: 'monthly',
            note: 'monthly fee when paid <u>each month</u>',
            _eur: '2.10'
          }
        }
      }
    }
  },
  preorderpuck: {
    label: 'pre-order',
    title: 'Pre-order waiting list',
    subtitle: 'Sign up for the Pre-Order list Today',
    lead: 'Sign up for our Puck Pre-order List and get a substantial discount !',
    slot: 'Please subscribe <b>now</b>, it takes one minute and you will then get:',
    form: {
      title: 'Subscribe to our pre-order list',
      topic: {
        label: 'How many Pucks would you be interested to buy?',
        placeholder: 'Please select your possible interest...',
        1: '1x: One Puck',
        2: '2x: Pack with two Pucks',
        4: '4x: Pack of Four',
        other: 'Other (please write us a message)'
      }
    },
    list: {
      1: 'Be first to be able to get a Puck when we start producing',
      2: 'You are entitled to get 30% introduction discount from <a href="/prices/puck">standard prices</a>',
      3: 'You are not obliged to anything!',
      4: 'We will keep you informed of our progress (maximal one email per two weeks)',
      5: 'You will encourage us to speed up development - Thank you !'
    },
    why: {
      title: 'Why a pre-order subscription list?',
      1: ' Puck is not yet available for purchase. We have started a <b>registry for our pre-order wait list</b> for when it becomes available to the general market. This registration is separate from our newsletter and designed solely for reserving a spot on our wait list.',
      2: 'This wait list is for Puck <b>future customers</b>. No payment information will be collected at this stage, and there is <b>no commitment</b> from your end, but registration will increase your priority level for first market batches.',
      3: 'In addition, we will offer you a one-time <b>30% discount</b> when you will proceed with the purchase as soon as we will start producing Puck',
      4: 'We will keep in touch with spam-free updates and more information when we have something substantial to tell you.',
      5: 'For more information please send us an email to <a href="mailto:info@qrespi.com">info@qrespi.com</a>, or even better:'
    }
  },
  services: {
    compare: {
      title: 'Service plan comparison',
      intro: 'The following table shows what service is offered by our "Free Plan" or "Care Plan":'
    },
    table: {
      header: {
        1: 'Service',
        2: 'Free Plan',
        3: 'Care Plan'
      },
      row: {
        1: {
          label: 'Puck Heartbeat',
          _plan: 'free, care',
          _icon: 'heart',
          _img: 'heartbeat.svg',
          title: 'Puck works reliably 24x7',
          slot: 'Our responsibility is to keep Puck working every day and night. Our communication servers should be buzzing day and night, but please realize that like any online technology there could be moments of interruption.<br><br><b>Please note: Puck is no substitute for official emergency services or emergency calls. Always call 911 in case of emergency!</b>',
          block: 'Feeling of security, knowing that Puck is online for you.'
        },
        2: {
          label: 'Web Account to configure your Puck',
          _plan: 'free, care',
          _icon: 'user-circle',
          _img: 'setup.png',
          title: 'Web account',
          slot: 'With Puck you will get a personal, unique "connect to care web account". In this web account you can program all your Pucks:<br>- write a message Puck should send<br>- choose a messenger (Telegram, WhatsApp, etc.) you would like Puck to use to send a message<br>- include name and mobile number of each person who you like to get your alert<br>- choose a person and mobile number automatic call (robot-voice) should be done to if anybody reads the message in the chat group<br>- select if Puck should make a sound when you press the button and if yes, select  a sound<br>- select what color the LED\'s should flash when you press the button<br>- identify if you would like to have periodical automatic test of Puck',
          block: 'One web account to set up all your Pucks'
        },
        3: {
          label: 'Sound Effects',
          _plan: 'free, care',
          _icon: 'music',
          _img: 'sound-effects.svg',
          title: 'Audio feedback',
          slot: 'You can choose if Puck should make a sound when you press the button. Usually you want Puck to make a sound when you press the button. But if you want him to be silent, that is possible. You can even select a different melody for each Puck.',
          block: 'Light and Sound effects tell you what is going on'
        },
        4: {
          label: 'Family & Friend Alerts - Telegram',
          _plan: 'free, care',
          _icon: 'brands/telegram',
          _img: 'telegram-alert.png',
          title: 'Care and Support Alerts delivered by Telegram',
          slot: 'The main service of Puck is to send alerts: notification messages to any chat group you like. The notification text you can set yourself in your web account.  <br><br>We suggest <a href="http://telegram.org">Telegram</a>  a chat application similar to WhatsApp but more secure and also totally free for businesses, e.g. Qrespi.',
          block: 'Fair use policy, so do not let kids play piano on your Pucks please.'
        },
        5: {
          label: 'Family & Friend Alerts - WhatsApp ao.',
          _plan: 'care',
          _icon: 'brands/whatsapp',
          _img: 'whatsapp-alert.png',
          title: 'Care and Support Alerts by WhatsApp & other chat apps',
          slot: 'This service is the same as the previous but instead of Telegram, your friends and family, can receive messages in their WhatsApp. To deliver messages by WhatsApp or Messenger, Facebook intends to charge Qrespi a fee and impose limits on what we can send. This is unfortunate, as it inhibits us to deliver alerts via WhatsApp as part of the Free Plan.',
          block: 'Fair use policy, so do not let kids play piano on your Pucks please.'
        },
        6: {
          label: 'Automated Follow-up Alerts',
          _plan: 'care',
          _icon: 'check-double',
          _img: 'follow-up.svg',
          title: 'Additional alert messages if needed',
          slot: 'What if you would tap Puck to send an alert to a chat group, and nobody in that chat group opens the message? Qrespi can provide the option to send a second, or third message to another chat group, even in another chat application with different people. You will increase the chances that someone sees your alert dramatically.',
          block: 'Additional attention from people that care for you.'
        },
        7: {
          label: 'Automated Robot Calls',
          _plan: 'care',
          _icon: 'robot',
          _img: 'robot-call.svg',
          title: 'Additional care by automatic calling',
          slot: 'What if all the people in your care-alert-group(s) muted their notifications? If nobody reads the alert message within for example 60 seconds, Qrespi can automatically call one or more preferred persons.',
          block: 'Additional attention from people that care for you.'
        },
        8: {
          label: 'Check in / Check Out',
          _plan: 'care',
          _icon: 'clock',
          _img: 'check-in-out.svg',
          title: 'Time limits and thresholds for actions',
          slot: 'This service allows you to configure a certain time and frequency when to expect a tap on the button. For example, you might like to ask grandmother to tap Puck before 11 at night. Now you will <i>only</i> get an alert if she did not tap Puck before that time. There are many applications for this service, for example parents might even tell their teenage daughter to tap Puck when they arrive home. So only if they arrive home before a certain time at night, Puck will not wake the parents...',
          block: 'Schedule the flow of life but without undesired intrusions.'
        },
        9: {
          label: 'Periodical Testing',
          _plan: 'care',
          _icon: 'exclamation-triangle',
          _img: 'automated-test.svg',
          title: 'Periodical Automatic Test as an extra option',
          slot: 'In your Puck web account you can choose to have every week or month am automatic check to test message alert or robot-call of Puck. On a day and time you select, Puck will send you the automatic test message in your private chat with Puck asking:<br><br>- to press one upper touch-button to check the message alert (if everything is good , in your private chat with Puck you should get same message what you send to others during the alert situation)<br>- to press bottom touch-button to check the robot-call. In this case Puck will check the validation of mobile number making a call to person you chose as a robot-call recipient in your web account.<br>The cost of this service is free of charge. You only pay for alert message and automatic call depending on messenger you use with Puck.<br><br><b>It will also test battery status.</b>',
          block: 'Be assured all works and keeps working...'
        }
      }
    }
  },
  solutions: {
    label: 'solutions',
    consumer: {
      label: 'consumers',
      title: 'where to use Puck?',
      header: 'Touch to Care',
      lead: 'Solutions for your daily life',
      payload: 'Actually in most rooms where you can imagine something could potentially happen, you could install a Puck.',
      quote: 'With Puck you offer your neighbours to help you just as you can help them&hellip;',
      1: {
        label: 'front  door',
        title: 'Front door safety',
        _img: 'frontdoor-m.jpg',
        intro: 'A typical application is for people who need to feel more safe at their own front door. With an alert you can have a neighbour coming over for assistance.'
      },
      2: {
        label: 'bathroom',
        title: 'Bathroom attend',
        _img: 'bathroom-m.jpg',
        intro: 'More than 60% of all home-accidents, happen in the bathroom. A Puck mounted next to the shower or bath, can make all the difference.'
      },
      3: {
        label: 'garden',
        title: 'Garden care',
        _img: 'garden-m.jpg',
        intro: 'As long as you stay within reach of your WiFi, you can carry Puck to places around the house. Don`t carry Puck in your pocket though. The button is sensitive.'
      },
      4: {
        label: 'kitchen',
        title: 'Kitchen Watch',
        _img: 'kitchen-m.jpg',
        intro: 'After the bathroom, the kitchen is a second place where you might like to alert some one.'
      },
      5: {
        label: 'bedroom',
        title: 'Good night',
        _img: 'bedroom-m.jpg',
        intro: 'Connect to care can also mean a little tap for a nice sign of attention… Thinking of you, Sweet dreams !'
      }
    },
    business: {
      label: 'business & organisations',
      title: 'Companies, organisations & associations',
      header: 'For business & organisations',
      lead: 'Serve your clients or members with efficient Connect-to-Care solutions',
      slot: 'We are happy to discuss any possible business cooperation',
      select: 'Select your business',
      type: {
        1: {
          label: 'home care',
          title: 'Home Care organisations',
          slot: 'For organisations that allow persons with special needs to stay in their home. It might be for people who are getting older, are chronically ill, recovering from surgery, or disabled.',
          _usps: '1,2,3,4'
        },
        2: {
          label: 'health clinic',
          title: 'Health care clinics',
          slot: 'For clinics and hospitals that care for people with chronic deceases.',
          _usps: '1,3,4'
        },
        3: {
          label: 'insurance',
          title: 'Health Insurance companies',
          slot: 'For carriers that offer products, such as individual and family health insurance, to people living independently at home.',
          _usps: '1,2,9,11'
        },
        4: {
          label: 'health consultant',
          title: 'E-health consultants',
          slot: 'For consulting companies that provide knowledge for improving technology integration in health care practices and municipals or governmental organisations.',
          _usps: '1,2,3,4,5,6,9,10'
        },
        5: {
          label: 'municipal',
          title: 'Health departments of Municipals',
          slot: 'Municipals that take care of their senior citizens by offering them access to modern technology, practical advise or financial support.',
          _usps: '1,2,3,4,7,10'
        },
        6: {
          label: 'retail',
          title: 'Health Aid - stores and shops',
          slot: 'For retail companies that sell aids, tools and devices directly to consumers. Qrespi helps you to become a modern "connect-to-care service provider".',
          _usps: '5,6,11'
        },
        7: {
          label: 'community',
          title: 'Neighbourhood communities',
          slot: 'For associations that support their neighbourhood with care or security.',
          _usps: '8,10'
        },
        8: {
          label: 'OEM',
          title: 'Original Equipment Manufacturers',
          slot: 'For companies that would like to use our wireless buttons as part of their own installations, offering and products.',
          _usps: '12',
          _image: 'oem-yacht.jpg'
        }
      },
      usp: {
        1: {
          title: 'Escalation prevention',
          slot: 'Do not allow your client to get from bad to worse. We found that you can achieve significant cost-reduction by preventing escalation of emergencies. For example unnecessary calling 911 by mild panic attacks.'
        },
        2: {
          title: 'Offloading trivial assistance',
          slot: 'It is possible to achieve some significant cost reduction by offloading trivial assistance to family & neighbours.'
        },
        3: {
          title: 'Workload reduction',
          slot: 'Reduce workload by involving families & neighbours for trivial care situations.'
        },
        4: {
          title: 'Share practical knowledge',
          slot: 'Give patients practical guidance for their security and comfort, even with limited budget.'
        },
        5: {
          title: 'Become a service provider',
          slot: 'Reposition as truly caring about client safety providing more total value to the clients.'
        },
        6: {
          title: 'Solution for Comfort',
          slot: 'An example: An appliance store offers Pucks with a steep discount with each bathroom or kitchen a senior buys.'
        },
        7: {
          title: 'Increase feeling of comfort',
          slot: 'Decrease the anxiety of the second generation with care assurance for their (lonely) parents'
        },
        8: {
          title: 'Community noise reduction',
          slot: 'Community noise reduction by focusing on actual emergencies'
        },
        9: {
          title: 'Investment opportunity',
          slot: 'Great investment opportunity in strongly growing market'
        },
        10: {
          title: 'Social adhesion',
          slot: 'Increase social connection between elderly people (communities) organizing their home spaces with maximum care and attention to secure & independent ageing'
        },
        11: {
          title: 'Positive PR',
          slot: 'Promote real interest in client well-being with low cost but highly visible connect-to-care solution'
        },
        12: {
          title: 'Great design, excellent price',
          slot: 'Puck has been thought-out to the smallest detail. You can apply Puck for both industrial and domestic purposes. We can customize colours, material and the labels to give our button the best appearance for your style or function. Various mount options, such as flush-mount brackets will be available. <br>Please contact us for possibilities.'
        }
      }
    }
  },
  technology: {
    label: 'technology',
    header: {
      title: 'Technology',
      subtitle: 'The challenge',
      lead: 'informed intuition | abundant experience'
    },
    software: {
      title: 'Software',
      payload: 'When developing apps, one of the biggest challenges is to choose the best programming <b>libraries</b> and <b>frameworks</b>. Our success in this challenge is one of our biggest assets.<br/><br/>Please note <b>this is a dynamic list</b>; preferences change over time due to market situations and development. ',
      1: {
        label: 'Web Apps',
        _icon: 'mobile',
        title: 'Web Apps',
        slot: '"A web application is a computer program that utilizes web browsers and web technology to perform tasks over the Internet." An important advantage of this approach is that developers will no longer need to develop multiple apps across multiple platforms. Even for those who develop only for iOS and Android, this means huge savings in time and effort. ',
        plus: {
          1: 'one code base for all platforms',
          2: 'mobile first',
          3: 'excellent performance',
          4: 'responsive design',
          5: 'no memory waste for install',
          6: 'shared with url',
          7: 'still distribute in App/Play Stores',
          8: 'automatic updates'
        }
      },
      2: {
        label: 'PWA',
        _icon: 'retweet',
        title: 'Progressive Web Apps',
        slot: 'A Progressive Web App are webapps that are capable of providing similar functionality and <b>seamless user interface</b> found in the best native apps; an experience that was previously hard to provide. It\'s important to realize that PWA\'s are <b>not hybrid</b> apps! Hybrid apps depend on an intermediate, non-standard, layer between the app and the device. This will lead to a <b>locked-in</b> development process.<br/><br/>Please read what Google has to say about <a href="https://developers.google.com/web/progressive-web-apps/" target="_blank">Progressive Web Apps</a>.',
        block: 'We expect that progressive webapps are the next big thing for the mobile web. It attracts a lot of attention because of the relative ease of development and almost instant wins for the application’s user experience.',
        plus: {
          1: '"progressive": instant loading',
          2: 'push notifications (native mobile)',
          3: 'keeps running off-line',
          4: 'fast',
          5: 'home screen icons on Android',
          6: 'various mobile hardware interfaces',
          7: 'approaching native apps'
        }
      },
      3: {
        label: 'Vue.js',
        _icon: 'code',
        title: 'VueJS Front-End Framework',
        slot: 'Vue.js is, let\'s face it, a <b>kick ass framework</b>. And it isn\'t just about writing great code. You need excellent documentation, a strong community helping each other learn, a supporting cast of libraries and plug-ins to help users solve the hard problems, and short feedback loops based on user feedback to keep the framework relevant. Vue.js is all of that, plus great code. That\'s why we\'re using it.',
        block: 'As a front-end web developer, I get to work with awesome people in workplace and get feedback for my ideas in the greater developer community. I love front-end development... and Vue.js!',
        image: 'vuejs.svg',
        plus: {
          1: 'templating - access .js with {{}}',
          2: 'reactivity - all automatic UI updates',
          3: 'components - encapsulate behaviour',
          4: 'use standard ES6 JavaScript rules(!)'
        }
      },
      4: {
        label: 'State',
        _icon: 'table',
        title: 'State Management',
        slot: 'Although the basic concept is as old as the way to Rome, <i>state management</i> in front-end software has been neglected for a long time. Now, since a few years, it\'s back and better than ever. <br/><br/>Basically, a "state" is  "one source of truth" for all activity in the front end. All logic, including the back-end server, <i>only</i> communicates by the <i>state</i>. This difference is not so visible with only a few components but very impressive when the number of inter-connections grow. No longer we accept deep links or so called "AJAX call spaghetti"... Refreshing!!',
        block: 'State-Management allows Lorinthe to focus on the User Interface. A well documented state-container connects to other parts of the application. It allows other software developers to concentrate on application logic and outsource the tedious UI work.',
        image: 'state-management.svg',
        plus: {
          1: 'Maintain the state of your UI such as keeping the sidebar opened or closed when changing routes.',
          2: 'Control the UI from any point of the application without worrying about how components are related or how to inject a specific service.',
          3: 'Chain UI layout-specific actions with other events such as saving data server-side or changing a route'
        }
      },
      5: {
        label: 'Node.js',
        _icon: 'brands/node',
        title: 'Node.js - server side JavaScript',
        slot: 'JavaScript is the language for adding interactivity to a website, but there\'s so much more it can do. Enter Node.js and Express.js, two technologies that extend the capabilities of JavaScript. The Node platform allows you to develop <b>server</b>-side applications with JavaScript that you can then easily publish as websites with the Express framework.',
        block: 'I\'m constantly and pleasantly surprised that for whatever little tool or demonstration I need, no matter how complex, Node.js greatly simplifies my life!',
        image: 'node.svg',
        plus: {
          1: 'one language for both server and client',
          2: 'high performance',
          3: 'easy to scale',
          4: 'fast delivery',
          5: 'sublime npm package management'
        }
      },
      6: {
        label: 'Realtime DB',
        _icon: 'database',
        title: 'Open-source databases for the real-time web',
        slot: 'Only a few years ago, database work was among the most boring of tasks in IT -- in a good way. Data went into one of the major SQL databases and it came out later, all in one piece, exactly as it went in. The database creators had succeeded in delivering rock-solid performance, and everyone started taking it for granted.<br/><br/>Then the nature of what we wanted to store changed. Databases had to move beyond bank accounts and airline tickets because everyone had begun sharing data on social networks. Suddenly there was much more data to store, and most of this new data didn’t fit into the old tables. The work of database admins and creators transformed, and what has emerged is a wide array of intriguing solutions that help to make databases among the more intriguing technologies today.',
        block: 'Lorinthe specializes in these modern databases: it is a pleasure to work with them and the end result is fast and flexible.',
        plus: {
          1: 'RethinkDB',
          2: 'MongoDB',
          3: '... and others'
        }
      },
      7: {
        label: 'Nginx',
        icon: 'server',
        title: 'Nginx Web and Proxy Server',
        slot: 'Nginx is a free, open-source, high-performance HTTP server. It is suited not only for web serving but also for reverse proxying, caching, load balancing, media streaming, and more.',
        block: 'We use Nginx in many of our PWA related projects for the simple fact that is creates a simple but very effective high availability setup in just minutes. ',
        plus: {
          1: 'high performance',
          2: 'stability',
          3: 'rich feature set',
          4: 'simple configuration',
          5: 'low resource consumption'
        }
      },
      8: {
        label: 'Docker',
        _icon: 'rocket',
        title: 'Docker',
        slot: 'Docker containers wrap a piece of software in a complete filesystem that contains everything needed to run: code, runtime, system tools, system libraries – anything that can be installed on a server. This guarantees that the software will always run the same, regardless of its environment.<br/>Docker provides this same capability without the overhead of a virtual machine. It lets you put your environment and configuration into code and deploy it. <br/>Lorinthe will help you to set up and maintain your containers.',
        block: 'Docker containers provide consistency in the turbulent world of software development environments.',
        plus: {
          1: 'Standardization & productivity',
          2: 'Compatibility & maintainability',
          3: 'Simplicity & faster configurations',
          4: 'Rapid Deployment',
          5: 'Isolation & Security'
        }
      },
      9: {
        label: 'Linux',
        _icon: 'brands/linux',
        title: 'Ubuntu & Linux based operating systems',
        slot: 'Ubuntu is a Debian-based Linux operating system for personal computers, tablets and smartphones. Since 2008 we have been working <b>exclusively</b> with this OS. <b>Everybody</b> in the company, from developers to secretaries, use any other OS. <br/><br/>Not all Windows or Mac applications run on Ubuntu but there are always good alternatives or better even: <b>cloud-based solutions</b>. The baker eats his own bread;)',
        block: 'We <b>all love Ubuntu!</b>. It\'s very productive, secure, fast and a daily pleasure to use.',
        image: 'ubuntu.svg',
        plus: {
          1: 'open source',
          2: 'secure - no virus avalanche',
          3: 'versatile',
          4: 'stable - stable - stable',
          5: 'compact - still runs fast on older hardware'
        }
      },
      10: {
        label: 'Chat',
        _icon: 'brands/telegram',
        title: 'Messaging Apps as the new Operating System?',
        slot: 'Chat apps became the enabler of all kind of services as a natural extension of our everyday toolbox. Lorinthe has abundant experience and developed a versatile <b>chat integration platform</b>.',
        block: 'Contact us and we can discuss how we can connect your service within a fast and effective messaging app infrastructure.',
        image: 'qrespi-workflow.svg',
        plus: {
          1: 'omni-present: we all use it',
          2: 'fast',
          3: 'direct',
          4: 'FREE'
        }
      },
      11: {
        label: 'Trello',
        _icon: 'brands/trello',
        title: 'Trello - Project management',
        slot: 'Trello is an awesome project management tool that makes collaboration easy and, dare we say, even fun. On top of the project management, this visual list tool can do so much more, whether you\'re organizing work projects, family chores, travel plans, or just about anything else.<br/>We like it, as Trello has everything you need to organize projects of any size. However we can use any project management tool or bug tracker.',
        block: 'Man, I love Trello. It’s a free, easy-to-use, collaborative, and highly visual tool with more than 10 million users around the world. I use it to help organize both my personal and professional life',
        plus: {
          1: 'boards; one board per project',
          2: 'lists; each suggesting a stage',
          3: 'cards; order sets priority',
          4: 'FREE'
        }
      },
      12: {
        label: 'Agile',
        _icon: 'stethoscope',
        title: 'Agile Project Management',
        slot: 'Agile methods grew out of the real-life project experiences of leading software professionals who had experienced the challenges and limitations of traditional waterfall development on project after project. The approach promoted by agile development is in direct response to the issue associated with traditional software development both in terms of overall philosophy as well as specific processes.',
        block: 'We believe in short cycles with immediate results, which we can test... every day.',
        image: 'scrum_process.svg',
        plus: {
          1: 'Stakeholder Engagement',
          2: 'Transparency',
          3: 'Early and Predictable Delivery',
          4: 'Predictable Costs and Schedule',
          5: 'Allows for Change',
          6: 'Focuses on Business Value',
          7: 'Focuses on Users'
        }
      }
    },
    hardware: {
      title: 'Hardware',
      payload: 'Qrespi uses state-of-the-art hardware design and production tools.',
      1: {
        label: '3D CAD',
        _icon: 'pencil-alt',
        _image: 'puck-explode.png',
        title: '3D Parametric Modeler',
        slot: 'To design the Puck and other hardware, we use 3D design, "Computer Aided Design" software or "CAD"',
        plus: {
          1: 'interactive design',
          2: 'extremely high accuracy',
          3: 'strength and force calculations',
          4: 'automatic drawing updates',
          5: 'export of exact models for CAM'
        }
      },
      2: {
        label: 'Electronics',
        _icon: 'pencil-alt',
        _image: 'elec-lab.jpg',
        title: 'Electronics Prototyping',
        slot: 'We use all kind of common tools for our electronics design.',
        plus: {
          1: 'breadboards',
          2: 'sensors',
          3: 'case materials',
          4: 'oscilloscope, multi meters',
          5: 'microscopes',
          6: 'SMD ovens'
        }
      },
      3: {
        label: 'Prototyping',
        _icon: 'pencil-alt',
        _image: '3d-printer.jpg',
        title: '3D Printing Prototyping',
        slot: 'We use special ultra-high resolution 3D printing.',
        plus: {
          1: 'material jet printing',
          2: 'UV hardening',
          3: 'ultra-high resolution',
          4: '1 day turn around time'
        }
      },
      4: {
        label: 'Injection Moulding',
        _icon: 'pencil-alt',
        _image: 'injection-molding.jpg',
        title: 'Low volume Injection moulding',
        slot: 'To test low volumes of our Puck, we use Silicon Moulds. With these moulds we can produce series of about 40-50 units to test.',
        plus: {
          1: 'low volumes',
          2: 'same result as high volume products',
          3: 'for end-user testing'
        }
      }
    }
  },
  testimonial: {
    title: 'what people are saying',
    1: 'Senior lady, recent widow: This is a real gap in the market. I want one for every room in my house.',
    2: 'Young female student, living alone: Puck makes me feel safer when someone calls on my door late at night.',
    3: 'Senior man: All these red alarm buttons that you are supposed to wear around your neck? What? I am not handicapped! A wall-button to slam on, is all I need.'
  },
  contact: {
    label: 'contact',
    title: 'contact us',
    caption: 'Send us a message, we will reply as soon as we can.',
    tips: {
      1: 'if you pay too much to develop native apps',
      2: 'if your current websites takes more than 2 seconds to load',
      3: 'would like to hear what we can do for you'
    },
    name: {
      label: 'Your name:'
    },
    salutation: 'salutation',
    firstname: {
      placeholder: 'First name'
    },
    lastname: {
      placeholder: 'Last name'
    },
    email: {
      label: 'Email address:',
      placeholder: 'you@domain.com',
      description: 'We will never share your email with anyone else.'
    },
    topic: {
      label: 'Topic',
      placeholder: 'Please select one topic',
      description: '',
      list: {
        1: 'Get your Early-bird Discount for Puck. No obligations!',
        2: 'Please, send me more information about Puck',
        3: 'For businesses, OEM, dealers, organisations',
        4: 'Customer support',
        5: 'Career',
        6: 'Press contact',
        7: 'Other'
      }
    },
    message: {
      label: 'Message',
      placeholder: 'Your message here...',
      description: ''
    },
    socialmedia: {
      share: 'Share this page',
      follow: '...or follow us on:',
      twitter: '@qrespi Puck by Qrespi - Touch to Care - Efficient safety button connects to your chat group.'
    }
  },
  responseform: {
    title: 'Contact form',
    ok: 'Thank you! We will get back to you as soon as possible.',
    failed: 'Sorry, something went wrong with the submission of your form ...',
    both: 'You can also send us an <b><a href=\'mailto:info@qrespi.com?subject=Qrespi Contact Request\'>email</a></b>  '
  },
  about_us: {
    label: 'about',
    header: {
      title: 'About us',
      subtitle: 'We believe',
      lead: 'Happiness | a continuous flow of achievement'
    },
    body: {
      intro: 'Qrespi International is an international <i>connect to care IT service provider</i> headquartered close to Amsterdam, The Netherlands.',
      usp: {
        1: 'Lorinthe,  parent company, since 1995',
        2: 'world class <b>webapps</b> for health, care and lifestyle',
        3: 'proven: thousands of daily users',
        4: 'international presence'
      }
    },
    specialize: {
      title: 'Specialization',
      slot: 'With many years of experience we develop, test and manage modern web-based applications as well as micro-controller based hardware devices. Our development specializes in (Progressive) Web Apps and Internet of Things. We are a true believer and supporter of open source software.'
    },
    // office:
    //   title: 'Workplace Philosophy'
    //   slot: 'Our workplaces form an ideal combination of serious work and pleasant freedom.'
    //   1:
    //     img: 'workbench.jpg'
    //     type: 'Micro cells'
    //     purpose: 'Efficient, distributed team work'
    //     slot: 'We have a work and location concept that we call "micro-cells". Basically we have teams with three people: two developers and the third being scrum master, tester and UI designer. Lorinthe even specially designed a <b>workbench</b> for our micro cells: three chairs and a large monitor to review work together. Our <b>micro cells</b> are an ideal combination of remote work and team work'
    //     block: 'the people love it: daily commute is minimized while there is still the daily life interaction and structure.'
    //   2:
    //     img: 'groupoffice.jpg'
    //     type: "Group office"
    //     purpose: 'Larger projects & Junior staff / training'
    //     slot: 'We look for places with natural light and an open and pleasant work atmosphere. We like our people to learn from each other first, before they can move on to a micro cell close to their home.'
    //     block: 'natural bright and... always good coffee!'
    team: {
      title: 'Business development team',
      intro: 'Qrespi\'s team brings decades of extensive industry knowledge and experience, plus a well-rounded business perspective.',
      1: {
        label: 'tom_v',
        name: 'Tom Voorneveld',
        title: 'founder & ceo',
        slot: 'With more than 25 years of experience in IT, software development, mobile technology, marketing and sales, Tom leads Qrespi. He has degrees in Business Administration and Technical Computer Science.'
      },
      2: {
        label: 'gena_s',
        name: 'Gennadiy Serdyuk',
        title: 'hardware liaison',
        slot: 'Gena has almost 30 years of experience in software development and electronics design. His specialization in connected electronics makes him the perfect candidate for Qrespi, intercommunication and the \'Internet of Things\'.'
      },
      3: {
        label: 'anna_k',
        name: 'Anna Khort',
        title: 'founder, marketing & operations',
        slot: 'Anna has a background in brand management and consumer products. She has a miraculously eye for detail and great passion for the success of Qrespi. Within Qrespi she oversees marketing and our operations.'
      },
      4: {
        label: 'sandra_s',
        name: 'Sandra Shevchenko',
        title: 'business development',
        slot: 'Sandra graduated at Business School and Institute of Investment Management, she is hard working, dedicated and with strong analytical skills. Within Qrespi she takes responsibility for our large accounts and alliances.'
      },
      20: {
        label: 'mykola_s',
        name: 'Mykola Slobodian',
        title: 'founder & cto',
        slot: 'Mykola has a strong background as manager in building digital services, developing cloud-based web & mobile applications, E-commerce, Service On-demand, Social Media and Business Tools. Providing software project infrastructure migration to the AWS or Google Cloud.'
      }
    },
    work: {
      title: 'Work with us',
      caption: 'We have a strong vision to develop <b>tailored tools</b> that enable people to increase their <b>quality of life</b>.',
      img: 'girl-qstand.jpg',
      interested: 'A career at Qrespi'
    }
  },
  resources: {
    label: 'resources',
    press: {
      label: 'Press kit'
    },
    blog: {
      label: 'blog',
      title: 'Blog',
      subtitle: 'Insights to Care',
      lead: 'On Internet of Things & Mutual Care',
      read_more: 'Read more',
      side: {
        title: 'Tags'
      }
    },
    docs: {
      label: 'documentation',
      title: 'Download Qrespi Information',
      subtitle: 'Resource Centre',
      lead: 'Practical usage information, white-papers, folders,..',
      1: {
        label: 'quick start',
        title: 'Quick setup guide for Puck',
        slot: 'How to quickly install Puck the very first time',
        img: 'quickstart.png',
        files: {
          en: 'Puck-setup-procedure-v05.pdf'
        },
        _type: 'pdf'
      },
      2: {
        label: 'leaflet',
        title: 'Introduction to Puck',
        slot: 'A first introduction to Puck and it\'s purpose',
        img: 'leaflet.png',
        files: {
          en: 'Puck-Intro-Leaflet-en-v01.pdf',
          nl: 'Puck-Intro-Leaflet-nl-v01.pdf'
        },
        _type: 'pdf'
      }
    },
    faq: {
      label: 'FAQ',
      title: 'Frequently Asked Questions',
      header: 'Be informed',
      lead: 'What else you like to know',
      slot: 'Please let us know if you can\'t find your answer:',
      1: {
        label: 'Setup Guide?',
        title: 'How do I set up Puck?',
        slot: 'Puck is very easy to set up. We created the how to do it step by step.<br>Every package of Puck will include printed version of setup guide.',
        link: {
          _href: '/docs',
          text: 'See our Quick start guide'
        }
      },
      2: {
        label: 'Working status?',
        title: 'How do I know Puck works? ',
        slot: 'Every Puck has LED  to help you to identify the status of the device.  When the LED is steady GREEN – Puck is ready to work, when the LED is flashing RED – Puck needs attention.  '
      },
      3: {
        label: 'Flashing RED Lights?',
        title: 'What should I do when LED is flashing RED?',
        slot: 'When LED on the Puck is flashing RED it means that something goes wrong and Puck is not ready for work. '
      },
      // link:
      //   _href: '/docs'
      //   text: 'See our Trouble Shoot guide'
      4: {
        label: 'Minimal cost?',
        title: 'What is the minimal cost I should pay to use Puck?',
        slot: 'If you only run one Puck, use Telegram for your notifications and do not set up additional services, you will pay the Heartbeat service 10*12 =120 tokens per year plus 1 token per each alert via Telegram.',
        link: {
          _href: '/puck/preorder',
          text: 'Join our pre-order list'
        }
      },
      5: {
        label: 'When to ship?',
        title: 'Do you know exact date of shipping?',
        slot: 'So far we are in “pre-order status”. As soon as we start Puck production and your e-mail is in our pre-order list, we will send an e-mail with a date of shipping and detailed guide how to purchase Puck. ',
        link: {
          _href: '/puck/preorder',
          text: 'Join our pre-order list'
        }
      },
      6: {
        label: 'Installation?',
        title: 'Can Puck be easily installed?',
        slot: 'Yes, we think so. Puck comes with two magnets on it\'s backside and metal plate with adhesive tape. You can attach Puck to any steel surface. Note that stainless steel not always contains enough iron to make Puck stick. Or you can stick metal plate to each surface using adhesive tape and attach Puck to this metal plate at any place you imagine the possibility to have Puck.'
      },
      7: {
        label: 'Web Account and subscription?',
        title: 'Do I need a web-account to use Puck?',
        slot: 'Yes, to use Puck you need to visit the link you will find on the back of your Puck. You can then create your own web account (profile) where you register Puck and manage its functionality (set up/ change text of messages, chose the melodies, create /change the lists of message recipients, etc.)'
      },
      8: {
        label: 'Monthly fee?',
        title: 'Is there any monthly fee I should pay?',
        slot: 'Puck works over your WiFi, which doesn\'t cost you anything extra. Each Puck has 10 tokens heartbeat fee per month to keep communication servers buzzing day and night. So there is <b>no monthly fee</b>, but you do need to top-of your token bundle at times.'
      },
      9: {
        label: 'WiFi connection?',
        title: 'Does Puck need a permanent WiFi connection?',
        slot: 'Yes, a permanent WiFi connection is required for Puck. When Puck doesn\'t have Internet connection the LED is flashing RED instead of GREEN when you tap its button.'
      },
      10: {
        label: 'Batteries?',
        title: 'What if the batteries run out?',
        slot: 'When the batteries are low, The LED will be flashing RED and you will  get a notification in your private chat with Puck that there is less than 5% of power.  If you don\'t change the batteries, Puck will not be able to keep working. '
      },
      11: {
        label: 'Privacy?',
        title: 'Do you store/save/use usage information via profile?',
        slot: 'No, we do not. We store only information you enter in your web account. We only use it to provide our service for you. We value your privacy as much as you do. All your personal information is encrypted and will not be shared with any third person. '
      },
      12: {
        label: 'Warranty?',
        title: 'What kind of warranty do you provide?',
        slot: 'Puck offers 1-year limited warranty, which means that if the device has any manufacture defect we will replace it if we receive the returned product within a period of 1 year from the date it is shipped. If the system is damaged by the customer, then we will not be able to replace or refund the device.'
      }
    }
  },
  career: {
    label: 'career',
    header: {
      title: 'Work with us',
      subtitle: 'Interface to Care',
      lead: 'creation | perfection'
    },
    intro: 'We are a start-up with optimistic and energetic professionals with years of experience. Our goal is to perfect the features and usability of webapps and websites while building a comprehensive product strategy.',
    vacancies: {
      title: 'Vacancies',
      payload: 'We currently have the following vacancies:'
    },
    incentive: 'If you feel you could support our vision and are attracted to be part of a highly professional start-up in an international playing field...please let us know:',
    jobs: {
      label: {
        tasks: 'tasks',
        require: 'he/she should',
        location: 'location'
      },
      M01: {
        jobtitle: 'Executive Assistant',
        description: 'The backbone of the team',
        quote: 'They may not always be at the front-and-centre of an organization, but an Executive Assistant is the unsung hero and Chief Efficiency Creator of any team.',
        tasks: {
          1: 'develop and maintain our CRM systems for sales and marketing information',
          2: 'manage our daily SCRUM meetings: chairing on-site and online meetings with the development team',
          3: 'master our ERP Platform: our \'bread and butter\'',
          4: 'report sales and marketing progress',
          5: 'organize our blogs',
          6: 'assist the management in various tasks as requested',
          7: 'assist clients by using our platform',
          8: 'host (international) events'
        },
        require: {
          1: 'have a strong drive and hands-on mentality',
          2: 'excellent English verbal and written skills',
          3: 'thriving in an entrepreneurial and self-starting environment',
          4: 'be positive, easy going, leveraging your creativity, insight, and intellect.',
          5: 'outstanding organization and time management skills, perfectionist',
          6: 'the ability to prioritize workload &amp; work on your own initiative',
          7: 'open mind; see the world as your playground',
          8: 'good representation'
        },
        location: {
          1: 'for our new team in the centre Kiev'
        },
        note: ''
      },
      U01: {
        jobtitle: 'User Experience Expert',
        description: 'Interfacing the Client',
        quote: 'It should look excellent, It must work perfect',
        tasks: {
          1: 'develop User Stories with your own clients',
          2: 'manage the account',
          3: 'design wireframe layouts for the client\'s apps',
          4: 'lead small scrum team as scrum master',
          5: 'test the developed software'
        },
        require: {
          1: 'have a strong drive and hands-on mentality',
          2: 'excellent English verbal and written skills',
          3: 'thriving in an entrepreneurial and self-starting environment',
          4: 'be positive, easy going and creative',
          5: 'perfectionist',
          6: 'good representation',
          7: 'experience with Agile / Scrum Teams',
          8: 'software testing experience',
          9: 'experience with graphical design tools (we use Inkscape)',
          10: 'willingness to keep learning'
        },
        location: {
          1: 'for our new team in the centre Kiev'
        }
      },
      M06: {
        jobtitle: 'Marketing Manager',
        description: 'The goal-getter',
        quote: 'Let\'s make a difference',
        tasks: {
          1: 'take charge of the Qrespi marketing plan',
          2: 'develop and manage our partner/agent channel',
          3: 'promote Lorinthe using online tools',
          4: 'generate free publicity',
          5: 'write promotional blogs',
          6: 'organise and maintain our CRM systems for sales and marketing information',
          7: 'manage our daily SCRUM meetings: chairing on-site and online meetings with the development team',
          8: 'master our Qrespi Platform: our \'bread and butter\'',
          9: 'report sales and marketing progress',
          10: 'test new Qrespi features and report bugs and write up new requirements'
        },
        require: {
          1: 'share our vision',
          2: 'be a self starter',
          3: 'have a strong sales and marketing drive',
          4: 'don\'t take \'no\' for an answer',
          5: 'can-do mentality',
          6: 'good English',
          7: 'proven sales track record',
          8: 'thriving in an entrepreneurial and self-starting environment leveraging your creativity, insight, and intellect',
          9: 'good organization and time management skills',
          10: 'work effectively with others but also on your own initiative'
        },
        location: {
          1: 'ability to travel if needed',
          2: 'relocate to Kiev or possibly abroad for certain periods of time',
          3: 'For our new team in Kiev, close to Metro University or Klovska.'
        },
        note: ''
      },
      T28: {
        jobtitle: 'Lead Software Developer',
        description: 'Working on your own product to conquer the world',
        quote: 'It\'s highly rewarding to develop your own project and be able to focus fully on your own world-class \'baby\'.',
        tasks: {
          1: 'master the development of Lorinthe: both front end back-end and server',
          2: 'be the proud leader of the technology of a new international, trend-setting product',
          3: 'grow and lead the development team along side the success of the company'
        },
        require: {
          1: 'take pride in your own product',
          2: 'be willing to learn new technology quickly',
          3: 'have a good command of English, so the communication between us is efficient',
          4: 'be enthusiastic, honest, full of initiative and flexible',
          5: 'be creative and able to come up with great ideas for our future',
          6: '5+ years web application development experience',
          7: '2+ years JavaScript , HTML5 / SCSS experience',
          8: 'understand or quickly master: Vue.js, Node.js, Express, REST, Socket.io, Docker, GIT, RethinkDB',
          9: 'we develop our software with Atom on Ubuntu'
        },
        location: {
          1: 'For our team in Kiev, remote work possible.'
        }
      },
      T31: {
        jobtitle: 'Front End Software Developer',
        description: 'Work in an international field at your own project',
        tasks: {
          1: 'development software at Lorinthe: mainly front end code',
          2: 'be the proud member of the technology of a new international, trend-setting product',
          3: 'embrace in the success of the company'
        },
        require: {
          1: 'take pride in your own product',
          2: 'be willing to learn new technology quickly',
          3: 'have a good command of English, so the communication between us is efficient',
          4: 'be enthusiastic, honest, full of initiative and flexible',
          5: 'be creative and able to come up with great ideas for our future',
          6: '5+ years web application development experience',
          7: '2+ years JavaScript , HTML5 / SCSS experience',
          8: 'understand or quickly master: Vue.js, Node.js, Express, REST, Socket.io, Docker, GIT, RethinkDB',
          9: 'we develop our software with Atom on Ubuntu'
        },
        location: {
          1: 'For our team in Kiev, remote work possible.'
        }
      },
      ALL: {
        jobtitle: 'Working at Qrespi',
        description: 'Apply for a new step in your career',
        quote: 'Serious Fun!',
        label: {
          tasks: 'general requirements',
          require: 'a plus',
          location: 'what we offer you'
        },
        tasks: {
          1: 'sufficient English both verbal as in writing',
          2: 'adhering to standards',
          3: 'good work-ethics',
          4: 'affinity with software, apps, on-line services',
          5: 'flexibility in hours when needed (especially applicable if you work for our US clients due to time-zone )',
          6: 'be mature and trustworthy',
          7: 'have good sense of humour',
          8: 'self-starter'
        },
        require: {
          1: 'willingness and ability to travel if needed'
        },
        location: {
          1: 'the thrill to work on your own world-class product',
          2: 'an excellent salary',
          3: 'bonus structure',
          4: 'business trips abroad when needed',
          5: 'a warm but very challenging atmosphere',
          6: 'English language courses (after 3 months)',
          7: 'flexible hours',
          8: 'possibility to work from home at times'
        },
        note: 'You think you qualify? Contact us and let us know in what job you are interested. Do not forget to tell us why you would like to work for Lorinthe and why you think you are a good addition to our team.'
      }
    }
  },
  footer: {
    copyright: 'copyright ©',
    terms: 'Lorinthe BV, the Netherlands. Our terms and conditions apply to all our services',
    language: 'language',
    is_update: 'There is a new version of this webapp',
    update_now: 'upgrade'
  },
  upgrade: {
    title: 'Upgrade your App',
    header: 'Update and reload',
    intro: 'Any progressive webapp, so also this site, will cache logic and data in your browser. This enables the app to run very fast and when you have no Internet connection. This also means that sometimes an upgrade to a new version can take some time, 24 hours is not unusual. If you do not want to wait that long, you can try to force update by clicking the link below.  <br/><br/>You are now running version ',
    click: 'Force reload'
  },
  not_found: {
    title: 'Sorry, we could not find this page'
  },
  def: {
    yes: 'yes',
    no: 'no',
    send: 'send',
    open: 'open',
    more: 'more',
    read_more: 'read more',
    close: 'close',
    home: 'home',
    site: 'site',
    buy: 'order',
    introduction: 'Introduction',
    signup: 'Sign up',
    submit: 'Submit',
    reset: 'Reset',
    download: 'download'
  }
};

export {
  en
};


//# sourceMappingURL=en.js.map
//# sourceURL=coffeescript
